import React, { memo } from "react";
import * as moment from "moment";
import * as util from "../../../../../../includes/util";

const VehicleHistoryItem = (props) => {
  const { item, isActive } = props;

  const clickedVehicle = () => {
    //console.log('VehicleHistoryItem.clickedVehicle');
    props.clickedVehicle(item);
  };

  const getStyle = () => {
    let className = "mapDetail";
    if (isActive) {
      className += " active";
    }
    if (item.Ignition === "False") {
      className += " speed-off";
    } else if (Number(item.Speed) === 0) {
      className += " speed-stop";
    } else {
      className += " speed-moving";
    }

    return className;
  };


  return (
    <li className={getStyle()} onClick={clickedVehicle}>
      <span></span>
      <div>
        <div className="row no-gutters">
          <div className="mr-3 mt-0">
            <div className="title history-text mt-0">
              <img className="mr-2" src={util.getVehicleIcon(item.RucMonkeyVehicleTypeId)} alt="odo" />
              {item.Odometer === "" ? "0" : item.Odometer}
            </div>
          </div>


          <div className="mr-3 mt-0">
            <div className="title history-text mt-0">
              <img className="mr-2" src="/assets/img/dateandtime.png" alt="time" />{moment(item.PositionTimestamp).format('DD/MM/YYYY HH:mm:ss')}
            </div>
          </div>
        </div>

        <div className="info">{item.LocationDescription}</div>
      </div>
      <span className="number">
        <span>{moment(item.PositionTimestamp).format("HH:mm:ss")}</span>
        <span></span>
      </span>
    </li>
  );
};

export default memo(VehicleHistoryItem);
